const SectionHeading = ({ title, subtitle, description }) => {
	return (
		<div className="flex flex-col my-6 space-y-2 group">
			<div className="flex items-center gap-3">
				{/* Horizontal line with gradient */}
				<div className="h-0.75 w-10 bg-linear-to-r from-brand-600 to-transparent transition-all duration-500 gh:w-20"></div>
				{/* Subtitle */}
				{subtitle && (
					<span className="text-xs font-black tracking-widest text-brand-500 uppercase">
						{subtitle}
					</span>
				)}
			</div>

			<h4 className="md:text-3xl text-2xl text-gray-900 uppercase Ethnocentric pl-2">
				{title}
			</h4>
			{description && <p className="text-gray-500 max-w-md">{description}</p>}
		</div>
	);
};

export default SectionHeading;
